import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';

// Circular Progress with Label
const CircularProgressWithLabel = ({ value }) => {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex', marginTop: '5%' }}>
      <CircularProgress
        variant="determinate"
        value={value}
        size={150}
        thickness={2}
        sx = {{color: 'var(--app-color)'}}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          color = "var(--app-color)"
        >{`${Math.round(value)}%`}</Typography>
      </Box>
    </Box>
  );
};

// Dynamic Download Loader Component
const DynamicDownloadLoader = ({ message, percentage }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        p: 2,
      }}
    >
      {/* Message */}
      <Typography variant="h6" align="center">
        {message}
      </Typography>

      {/* Circular Progress */}
      <CircularProgressWithLabel value={percentage} />
    </Box>
  );
};

export default DynamicDownloadLoader;